import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/system'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const listTypeToTabIndex = {
  parameters: 1,
}

const CustomTab = ({ to, ...props }) => {
  return (
    <Link to={to}>
      <Tab component="p" {...props} />
    </Link>
  )
}

const RulesHeader = ({ listType }) => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <Container>
      <div style={{ display: 'flex' }}>
        <Tabs value={listTypeToTabIndex[listType]}>
          <CustomTab
            to={`${location.pathname}?type=parameters`}
            label={t('rules.parameters.title')}
          />
        </Tabs>
      </div>
    </Container>
  )
}

RulesHeader.propTypes = {
  listType: T.oneOf(['parameters']).isRequired,
}

export default RulesHeader

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))
